// fallback empty string
export const getIndexValue = (arr: any[], index: number): any => {
  if (arr && arr.length - 1 >= index) {
    return arr[index];
  }
  return '';
};

export const getKeyByValue = (obj: Record<any, any>, value: any): any =>
  Object.keys(obj).find((key) => obj[key] === value);

export const existInArray = (array: string[] | undefined, item: string): boolean =>
  array !== undefined && array.indexOf(item) > -1;
